import React, { FC } from 'react';

import WebdoorContent from './WebdoorContent';
import withMediaQueries from '../MediaQueries';

import { IWebdoorList } from './interfaces';

import './styles.scss';

// webdoor
const WebdoorList: FC<IWebdoorList> = ({
  lang,
  queries,
  value
}) => {
  // render
  return (
    <div
      className="webdoor-list">
      <WebdoorContent
        items={value}
        queries={queries}
        lang={lang} />
    </div>
  );
};

export default withMediaQueries(WebdoorList);